module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mdigurp7-db049086fd7e5e0d2b7e0506300528bc.jpg";